import { render, staticRenderFns } from "./ArmLink.vue?vue&type=template&id=24d14a16&scoped=true&"
import script from "./ArmLink.vue?vue&type=script&lang=js&"
export * from "./ArmLink.vue?vue&type=script&lang=js&"
import style0 from "./ArmLink.vue?vue&type=style&index=0&id=24d14a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d14a16",
  null
  
)

export default component.exports